// Link represents a link in a REST API response
export interface Link {
  method?: string; // the HTTP method
  rel?: string; // this link's link relation
  href?: string; // the full URL of the linked resource
  uri: string; // the name of the linked resource, without the base URL
  type?: string; // this link's preferred media type (Called MediaType in Go struct)
  responseType?: string; // this link's response media type
  itemType?: string; // describes the media type of the elements of the top level primary response collection
  responseItemType?: string; // describes the type of the items in the response body
  title?: string; // describes this link's preferred name
}

// Collection represents a collection of items in a REST API response
// int is sufficient for "Start" and "Count" because all target platforms are 64 bit
export interface Collection<T> {
  version?: number; // the version
  accept?: string; // space-separated list of link types of the items
  count?: number; // the number of items in the collection
  start?: number; // the index of the first item in the collection
  limit?: number; // the number of items to return in each page
  name?: string; // abstract name of the the collection; what the "items" member represents
  items: T[]; // the items in this page of the collection
  links?: Link[];
}

const CollectionMediaType = 'application/vnd.sas.collection';
export const CollectionMediaTypeJSON = `${CollectionMediaType}+json`;
